'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var ZoomOption;
(function (ZoomOption) {
    ZoomOption[ZoomOption["Custom"] = 0] = "Custom";
    ZoomOption[ZoomOption["Auto"] = 1] = "Auto";
    ZoomOption[ZoomOption["Actual"] = 2] = "Actual";
    ZoomOption[ZoomOption["PageFit"] = 3] = "PageFit";
    ZoomOption[ZoomOption["PageWidth"] = 4] = "PageWidth";
    ZoomOption[ZoomOption["Percentage_50"] = 5] = "Percentage_50";
    ZoomOption[ZoomOption["Percentage_75"] = 6] = "Percentage_75";
    ZoomOption[ZoomOption["Percentage_100"] = 7] = "Percentage_100";
    ZoomOption[ZoomOption["Percentage_125"] = 8] = "Percentage_125";
    ZoomOption[ZoomOption["Percentage_150"] = 9] = "Percentage_150";
    ZoomOption[ZoomOption["Percentage_200"] = 10] = "Percentage_200";
    ZoomOption[ZoomOption["Percentage_300"] = 11] = "Percentage_300";
    ZoomOption[ZoomOption["Percentage_400"] = 12] = "Percentage_400";
})(ZoomOption || (ZoomOption = {}));
var CSS_UNITS = 96 / 72;
var VIEWER_CONTAINER = "page-viewer";
var PDF_VIEWER_BASE_HEIGHT = 792;
var PDF_VIEWER_BASE_WIDTH = 612;
var ToolbarBase = /** @class */ (function () {
    function ToolbarBase() {
    }
    ToolbarBase.prototype.getScaleFromZoomOption = function (zoomOption) {
        switch (zoomOption) {
            case ZoomOption.Custom:
                return 0;
            case ZoomOption.Auto:
                return this.getAutoScale();
            case ZoomOption.Actual:
                return 1;
            case ZoomOption.PageFit:
                return this.getPageFitScale();
            case ZoomOption.PageWidth:
                return this.getPageWidthScale();
            case ZoomOption.Percentage_50:
                return .5;
            case ZoomOption.Percentage_75:
                return .75;
            case ZoomOption.Percentage_100:
                return 1;
            case ZoomOption.Percentage_125:
                return 1.25;
            case ZoomOption.Percentage_150:
                return 1.5;
            case ZoomOption.Percentage_200:
                return 2;
            case ZoomOption.Percentage_300:
                return 3;
            case ZoomOption.Percentage_400:
                return 4;
            default:
                return 1;
        }
    };
    ToolbarBase.prototype.togglePanelClass = function (elementId) {
        var element = document.getElementById(elementId);
        if (element && element.classList.contains("collapsed")) {
            element.classList.remove("collapsed");
            element.classList.add("active-panel");
        }
        else {
            element && element.classList.add("collapsed");
            element && element.classList.remove("active-panel");
        }
    };
    ToolbarBase.prototype.openFullscreen = function () {
        var bodyElement = document.getElementsByTagName("body")[0];
        if (bodyElement.requestFullscreen) {
            bodyElement.requestFullscreen();
        }
        else if (bodyElement.mozRequestFullScreen) { /* Firefox */
            bodyElement.mozRequestFullScreen();
        }
        else if (bodyElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
            bodyElement.webkitRequestFullscreen();
        }
        else if (bodyElement.msRequestFullscreen) { /* IE/Edge */
            bodyElement.msRequestFullscreen();
        }
    };
    ToolbarBase.prototype.closeFullscreen = function () {
        var doc = document;
        if (doc.exitFullscreen) {
            doc.exitFullscreen();
        }
        else if (doc.mozCancelFullScreen) { /* Firefox */
            doc.mozCancelFullScreen();
        }
        else if (doc.webkitExitFullscreen) { /* Chrome, Safari and Opera */
            doc.webkitExitFullscreen();
        }
        else if (doc.msExitFullscreen) { /* IE/Edge */
            doc.msExitFullscreen();
        }
    };
    ToolbarBase.prototype.downloadFile = function (url, fileName, onAfterDownloadCallBack) {
        this.download(url, fileName, onAfterDownloadCallBack);
    };
    ToolbarBase.prototype.getAutoScale = function () {
        return screen.width >= 1200 ? 1 : (screen.width / 1200) + .10; // scree size >= 1200 is laptop so scale will be set to 1
    };
    ToolbarBase.prototype.getPageFitScale = function () {
        var viewerContainer = document.getElementById(VIEWER_CONTAINER);
        if (viewerContainer) {
            var scaleBasedOnHeight = viewerContainer.clientHeight / (PDF_VIEWER_BASE_HEIGHT * CSS_UNITS);
            var scaleBasedOnWidth = viewerContainer.clientWidth / (PDF_VIEWER_BASE_WIDTH * CSS_UNITS);
            return Math.min(scaleBasedOnHeight, scaleBasedOnWidth);
        }
        return 1;
    };
    ToolbarBase.prototype.getPageWidthScale = function () {
        var viewerContainer = document.getElementById(VIEWER_CONTAINER);
        if (viewerContainer) {
            return viewerContainer.clientWidth / (PDF_VIEWER_BASE_WIDTH * CSS_UNITS);
        }
        return 1;
    };
    ToolbarBase.prototype.download = function (url, filename, onAfterDownloadCallBack) {
        var a = document.createElement("a");
        a.href = url;
        a.setAttribute("download", filename ? filename : "file.pdf");
        a.click();
        onAfterDownloadCallBack(filename);
    };
    return ToolbarBase;
}());

var Strings_Toolbar = /** @class */ (function () {
    function Strings_Toolbar() {
    }
    Strings_Toolbar.leftPaneToggleButtonTooltip = "Toggle Left Panel";
    Strings_Toolbar.rightPaneToggleButtonTooltip = "Toggle Right Panel";
    Strings_Toolbar.firstPageButtonTooltip = "First Page";
    Strings_Toolbar.previousPageButtonTooltip = "Previous Page";
    Strings_Toolbar.nextPageButtonTooltip = "Next Page";
    Strings_Toolbar.lastPageButtonTooltip = "Last Page";
    Strings_Toolbar.zoomOutButtonTooltip = "Zoom Out";
    Strings_Toolbar.zoomInButtonTooltip = "Zoom In";
    Strings_Toolbar.fullscreeButtonTooltip = "Full Screen";
    Strings_Toolbar.exitFullscreeButtonTooltip = "Exit Full Screen";
    Strings_Toolbar.readModeTooltip = "Read Mode";
    Strings_Toolbar.exitReadModeTooltip = "Exit Read Mode";
    Strings_Toolbar.downloadIconTooltip = "Download";
    return Strings_Toolbar;
}());

var Zoom = /** @class */ (function (_super) {
    __extends(Zoom, _super);
    function Zoom(props) {
        var _this = _super.call(this, props) || this;
        _this._toolbarBase = new ToolbarBase();
        _this.handleZoomOptionChange = function (event) {
            var scale = _this._toolbarBase.getScaleFromZoomOption(Number(event.target.value));
            _this.setState({ selectedZoomOption: event.target.value }, function () {
                _this.props.onZoomOptionChange && _this.props.onZoomOptionChange(scale);
            });
        };
        _this.handleZoomIn = function () {
            _this.setState({ selectedZoomOption: ZoomOption.Custom }, function () {
                _this.props.onZoomIn && _this.props.onZoomIn();
            });
        };
        _this.handleZoomOut = function () {
            _this.setState({ selectedZoomOption: ZoomOption.Custom }, function () {
                _this.props.onZoomOut && _this.props.onZoomOut();
            });
        };
        _this.state = {
            selectedZoomOption: ZoomOption.Auto
        };
        return _this;
    }
    Zoom.prototype.componentDidMount = function () {
    };
    Zoom.prototype.render = function () {
        return (React.createElement("div", { className: "icon-bar d-none d-sm-block" },
            React.createElement("a", { className: "icon", onClick: this.handleZoomOut, title: Strings_Toolbar.zoomOutButtonTooltip },
                React.createElement("i", { className: "fa fa-search-minus" })),
            React.createElement("a", { className: "icon", onClick: this.handleZoomIn, title: Strings_Toolbar.zoomInButtonTooltip },
                React.createElement("i", { className: "fa fa-search-plus" })),
            React.createElement("select", { className: "form-control toolbar-item-form-control toolbar-item-select ", title: "Zoom", onChange: this.handleZoomOptionChange, value: this.state.selectedZoomOption },
                React.createElement("option", { key: "pageCustomOption", id: "pageCustomOption", title: "", value: ZoomOption.Custom, disabled: true }, "Custom Zoom"),
                React.createElement("option", { key: "pageAutoOption", id: "pageAutoOption", title: "", value: ZoomOption.Auto }, "Automatic Zoom"),
                React.createElement("option", { key: "pageFitOption", id: "pageFitOption", title: "", value: ZoomOption.PageFit }, "Page Fit"),
                React.createElement("option", { key: "pageWidthOption", id: "pageWidthOption", title: "", value: ZoomOption.PageWidth }, "Page Width"),
                React.createElement("option", { key: ZoomOption.Percentage_50, title: "", value: ZoomOption.Percentage_50 }, "50%"),
                React.createElement("option", { key: ZoomOption.Percentage_75, title: "", value: ZoomOption.Percentage_75 }, "75%"),
                React.createElement("option", { key: ZoomOption.Percentage_100, title: "", value: ZoomOption.Percentage_100 }, "100%"),
                React.createElement("option", { key: ZoomOption.Percentage_125, title: "", value: ZoomOption.Percentage_125 }, "125%"),
                React.createElement("option", { key: ZoomOption.Percentage_150, title: "", value: ZoomOption.Percentage_150 }, "150%"),
                React.createElement("option", { key: ZoomOption.Percentage_200, title: "", value: ZoomOption.Percentage_200 }, "200%"),
                React.createElement("option", { key: ZoomOption.Percentage_300, title: "", value: ZoomOption.Percentage_300 }, "300%"),
                React.createElement("option", { key: ZoomOption.Percentage_400, title: "", value: ZoomOption.Percentage_400 }, "400%")),
            React.createElement("a", { className: "divider d-none d-sm-block" })));
    };
    Zoom.displayName = "Zoom";
    return Zoom;
}(React.Component));

exports.default = Zoom;
exports.Zoom = Zoom;
